/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ account: NonNullable<unknown> }} Notice_Link_OpenedInputs */

const en_notice_link_opened = /** @type {(inputs: Notice_Link_OpenedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.account} opened their booking link`)
};

/**
* | output |
* | --- |
* | "{account} opened their booking link" |
*
* @param {Notice_Link_OpenedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const notice_link_opened = /** @type {((inputs: Notice_Link_OpenedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notice_Link_OpenedInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_notice_link_opened(inputs)
});